import React from 'react';
import './GameIcon.css';

import FrozenArcticIcon from './frozen-arctic@2x.png';
import FiestaSenoritaIcon from './fiesta-senorita@2x.png';
import JumpingJackIcon from './jumping-jack@2x.png';
import KingLuauIcon from './king-luau@2x.png';
import LoveBiteIcon from './love-bite@2x.png';
import LuckMinerIcon from './luck-miner.png';
import MoneyHoneyIcon from './money-honey.png';
import Roaring7sIcon from './roaring-7s.png';
import ShadowsOfOlympusIcon from './shadows-of-olympus.png';
import TripleSapphireSevensIcon from './triple-sapphire-sevens.png';
import TripleTreasuresIcon from './triple-treasures.png';
import WildGypsyIcon from './wild-gypsy.png';
import CheekyTikiIcon from './cheeky-tiki.png';
import DragonPalaceIcon from './dragon-palace.png';
import TiponisWildsIcon from './tiponis-wilds.png';
import MoneyRainIcon from './it_moneyrain.png';
import WildStreakGypsyRichesIcon from './wildstreak_gypsyriches.png';
import SoaringStallionIcon from './soaringstallion.png';
import TripleBombShellBettiesIcon from './triplebombshellbetties.png';
import VoyageToAsgardIcon from './voyagetoasgard.png';

export const GAME_IMAGES = {
  fiestasenorita: FiestaSenoritaIcon,
  frozenarctic: FrozenArcticIcon,
  jumpingjackcash: JumpingJackIcon,
  kingoftheluau: KingLuauIcon,
  lovebite: LoveBiteIcon,
  luckminer: LuckMinerIcon,
  moneyhoney: MoneyHoneyIcon,
  roaring7s: Roaring7sIcon,
  shadowsofolympus: ShadowsOfOlympusIcon,
  triplesapphiresevens: TripleSapphireSevensIcon,
  tripletreasures: TripleTreasuresIcon,
  wildgypsy: WildGypsyIcon,
  nektan_cheekytiki: CheekyTikiIcon,
  dragonpalace: DragonPalaceIcon,
  tiponiswilds: TiponisWildsIcon,
  it_moneyrain: MoneyRainIcon,
  wildstreak_gypsyriches: WildStreakGypsyRichesIcon,
  soaringstallion: SoaringStallionIcon,
  triplebombshellbetties: TripleBombShellBettiesIcon,
  voyagetoasgard: VoyageToAsgardIcon
};

function GameIcon({ game, alt }) {
  return (
    <div className="game-icon">
      <img src={GAME_IMAGES[game]} alt={alt} />
    </div>
  );
}

export default GameIcon;



// WEBPACK FOOTER //
// ./src/components/GameIcon/index.js